import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AktieServiceConfig = {
  name: "Aktie",
  annotations: []
} as ServiceConfig;